import { render, staticRenderFns } from "./SettlementFooter.vue?vue&type=template&id=c53ad620&scoped=true&"
import script from "./SettlementFooter.vue?vue&type=script&lang=js&"
export * from "./SettlementFooter.vue?vue&type=script&lang=js&"
import style0 from "./SettlementFooter.vue?vue&type=style&index=0&id=c53ad620&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Users/Mac/Desktop/Code/permtang/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53ad620",
  null
  
)

export default component.exports